import { useEffect, useRef, useState } from "react";

function isMobile() {
  return window.matchMedia("(pointer: coarse)").matches;
}

const Cursor = () => {
  const [mobile, setMobile] = useState(isMobile());
  const cursorRef = useRef(null);
  const rafRef = useRef(null);
  const hoverRef = useRef(false);

  useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (mobile) return; // Don't attach listeners on mobile

    const handleMouseMove = (e) => {
      const cursor = cursorRef.current;
      if (!cursor) return;

      const updateCursor = () => {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      };

      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      rafRef.current = requestAnimationFrame(updateCursor);

      const hoveringInteractive = Boolean(
        e.target.closest(
          "a, button, .nav-dot, .skill-tag, .logo-main, .social-icon"
        )
      );

      if (hoverRef.current !== hoveringInteractive) {
        hoverRef.current = hoveringInteractive;
        cursor.classList.toggle("hovering", hoveringInteractive);
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
  }, [mobile]);

  if (mobile) return null; // <--- Don't render cursor on mobile

  return <div ref={cursorRef} className="cursor" />;
};

export default Cursor;
